import "./ProfileCard.scss";
import {ReactNode} from "react";
import {useMinSpin, MIN_SPIN_MS as SITE_MIN_SPIN_MS} from "../../../../hooks/useMinSpin";

// спінер крутиться щонайменше стільки, навіть якщо сервер відповів миттєво, — інакше він лише блимає
export const MIN_SPIN_MS = SITE_MIN_SPIN_MS;

// Виконує запит і чекає, щоб від початку минуло не менше MIN_SPIN_MS
export const withMinSpin = async <T,>(run: () => Promise<T>): Promise<T> => {
    const startedAt = Date.now();
    try {
        return await run();
    } finally {
        const left = MIN_SPIN_MS - (Date.now() - startedAt);
        if (left > 0) await new Promise((resolve) => setTimeout(resolve, left));
    }
};

// Кнопка картки профілю: під час запиту текст невидимий (кнопка не міняє ширину), а по центру спінер
export const SpinButton = ({ loading, disabled, children, type = "submit", onClick, className = "" }: {
    loading: boolean,
    disabled?: boolean,
    children: ReactNode,
    type?: "submit" | "button",
    onClick?: () => void,
    className?: string,
}) => {
    const spinning = useMinSpin(loading);
    return (
    <button
        type={type}
        onClick={onClick}
        disabled={disabled && !spinning}
        aria-busy={spinning}
        className={`bc-submit ${spinning ? "is-loading" : ""} ${className}`}
    >
        <span className="bc-submit-text">{children}</span>
        { spinning && <span className="bc-spinner" aria-hidden="true" /> }
    </button>
    );
};

// Шапка картки: іконка в синьому квадраті, заголовок і пояснення
export const CardHead = ({ icon, title, text }: { icon: ReactNode, title: ReactNode, text?: ReactNode }) => (
    <>
        <div className="bc-icon" aria-hidden="true">{icon}</div>
        <h3 className="bc-title">{title}</h3>
        { text && <p className="bc-text">{text}</p> }
    </>
);
